import GridLoader from "react-spinners/GridLoader";

function Loading(){
    const override = {
        display: "block",
        margin: "0 auto",
    };
    return(
        <>
            <GridLoader
                color={"var(--blue)"}
                cssOverride={override}
                size={15}
                aria-label="Loading Spinner"
                data-testid="loader"
            />
        </>
    )
}

export default Loading